module.exports = __webpack_public_path__ + "application/templates/privacy-policies/privacy-policies.template.html";